import { backendRequest } from "../../../stores/thunks";
import store from "../../../stores/store";
import { setMessage } from "../../../stores/mainSlice";

const MAX_MB = 30;
const factor = 1000 // web
const MAX_MEDIA = MAX_MB * factor * factor;

export async function getMedia(mediaId) {
    const mediaIdString = mediaId + ''
    const server = store.getState().server
    const API_URL = server.url + server.api + `/studio/workflow/media/${mediaIdString.split('.')[0]}`

    try {
        const response = await fetch(API_URL, {method: 'GET'})
        console.log('STUDIO GET Media:', response)
        return response
    } catch (error) {
        console.log('STUDIO GET Media: Error', error)
        return error
    }
}

export async function uploadMedia(flowId, image) {
    const server = store.getState().server
    const API_URL = server.url + server.api + `/studio/workflow/${flowId}/media`

    try {
        // The BTOA encoded data is 1/3 bigger than the actual data
        const size = image.uri.length / 4 * 3
        if (size > MAX_MEDIA) {
            store.dispatch(setMessage({
                msg: {
                    level: 'warning',
                    text: 'global.mediaSize',
                    options: { size: Math.ceil(size * 100 / factor / factor) / 100, max: MAX_MB },
                    i18n: true
                }
            }))
            return null
        }
        const res = await fetch(image.uri)
        const blob = await res.blob()
        if (blob.size > MAX_MEDIA) {
            // should actually not happen because of the size check above
            store.dispatch(setMessage({
                msg: {
                    level: 'warning',
                    text: 'global.mediaSize',
                    options: { size: Math.ceil(blob.size * 100 / factor / factor) / 100, max: MAX_MB } ,
                    i18n: true
                }
            }))
            return null
        }
        const fd = new FormData();
        const file = new File([blob], "filename." + image.uri.split(",")[0].split(":")[1].split(";")[0].split("/")[1]);
        fd.append('file', file)
        fd.append('mimetype', image.uri.split(",")[0].split(":")[1].split(";")[0])

        const response = await fetch(API_URL, {method: 'POST', body: fd})
        const result = await response.json();
        console.log('STUDIO UPLOAD Media', result)
        return result
    } catch (error) {
        console.log('STUDIO UPLOAD Media: Error', error)
        store.dispatch(setMessage({
            msg: {
                level: 'error',
                text: 'global.mediaUpload',
                options: {error: '' + error},
                i18n: true
            }
        }))
        return error
    }
}

export async function mediaImport(studioId, tgtWorkflowId, mediaList) {
    try {
        const result = await store.dispatch(backendRequest('STUDIO_MEDIA_EXPORT', `/studio/workflow/${studioId}/media-import`, {
            tgtWorkflowId: tgtWorkflowId,
            mediaList: mediaList
        }, 'POST', false))
        console.log('STUDIO Media-Import', result)
        return result
    } catch (error) {
        console.log('STUDIO Media-Import: Error', error)
        return error
    }
}
